import { HTMLAttributes } from "react"
import { Property } from "csstype"
import { styled, StyleProps, CSSFn, callCSSFn } from "../styles"
import { boxCss } from "../Box"

interface SeparatorProps extends HTMLAttributes<HTMLDivElement> {
  size: `block` | `hairlineShort` | `hairlineFull`
  color: `yellow` | `gray` | `red` | `white`
  css?: CSSFn
}

type StyledSeparatorProps = SeparatorProps & StyleProps

const getBackgroundColor =
  (color: `yellow` | `gray` | `red` | `white`) =>
  (props: StyleProps): Property.Color => {
    switch (color) {
      case `yellow`:
        return props.theme.palette.brand
      case `gray`:
        return props.theme.palette.grey.dark
      case `red`:
        return props.theme.palette.full.red
      case `white`:
        return props.theme.palette.white
      default:
        return props.theme.palette.brand
    }
  }

export const Separator = styled.div<SeparatorProps>((props: StyledSeparatorProps) => ({
  ...boxCss,
  flexShrink: 0,
  cursor: `default`,
  margin: props.theme.spacing(3, 0),
  width: props.size === `hairlineFull` ? `100%` : props.theme.spacing(9),
  height: props.size === `block` ? props.theme.spacing(2) : `1px`,
  backgroundColor: getBackgroundColor(props.color)(props),
  ...callCSSFn(props),
}))
